import {
  useCreateVendorMutation,
  useLazyGetAllVendorsQuery,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
  useLazyVendorDetailsQuery,
} from "../store/services/vendorsQuery";

export const useVendors = () => {
  const [
    createVendor,
    {
      data: createVendorData,
      isLoading: createVendorIsLoading,
      isError: createVendorIsError,
      error: createVendorError,
      isSuccess: createVendorIsSuccess,
    },
  ] = useCreateVendorMutation();
  const [
    getAllVendors,
    {
      data: allVendorsData,
      isLoading: allVendorsIsLoading,
      isError: allVendorsIsError,
      error: allVendorsError,
      isSuccess: allVendorsIsSuccess,
    },
  ] = useLazyGetAllVendorsQuery();
  const [
    updateVendor,
    {
      data: updateVendorData,
      isLoading: updateVendorIsLoading,
      isError: updateVendorIsError,
      error: updateVendorError,
      isSuccess: updateVendorIsSuccess,
    },
  ] = useUpdateVendorMutation();
  const [
    deleteVendor,
    {
      data: deleteVendorData,
      isLoading: deleteVendorIsLoading,
      isError: deleteVendorIsError,
      error: deleteVendorError,
      isSuccess: deleteVendorIsSuccess,
    },
  ] = useDeleteVendorMutation();
  const [
    getVendorDetails,
    {
      data: VendorDetailsData,
      isLoading: VendorDetailsIsLoading,
      isError: VendorDetailsIsError,
      error: VendorDetailsError,
      isSuccess: VendorDetailsIsSuccess,
    },
  ] = useLazyVendorDetailsQuery();

  return {
    createVendor,
    createVendorData,
    createVendorIsLoading,
    createVendorIsError,
    createVendorError,
    createVendorIsSuccess,
    getAllVendors,
    allVendorsData,
    allVendorsIsLoading,
    allVendorsIsError,
    allVendorsError,
    allVendorsIsSuccess,
    updateVendor,
    updateVendorData,
    updateVendorIsLoading,
    updateVendorIsError,
    updateVendorError,
    updateVendorIsSuccess,
    deleteVendor,
    deleteVendorData,
    deleteVendorIsLoading,
    deleteVendorIsError,
    deleteVendorError,
    deleteVendorIsSuccess,
    getVendorDetails,
    VendorDetailsData,
    VendorDetailsIsLoading,
    VendorDetailsIsError,
    VendorDetailsError,
    VendorDetailsIsSuccess,
  };
};
